// The conversation's first page, asked for at the CLICK (mousedown), before React has even
// re-rendered — and the last page of the few most recent conversations, kept in memory so going
// back to one paints its previous state on the first frame while the store is re-read underneath
// (stale-while-revalidate, the same rule as everything else). Bounded: eight conversations.
import { data } from '../bridge/client';
import type { ChannelPage } from '../bridge/protocol';

const MAX = 8;
const pages = new Map<string, ChannelPage>();
const inflight = new Map<string, Promise<ChannelPage>>();

export const FIRST_PAGE = 60;

export function prefetchPage(channelId: string): Promise<ChannelPage> {
  const existing = inflight.get(channelId);
  if (existing) return existing;
  const p = data.call('channelPage', channelId, FIRST_PAGE).then((page) => {
    remember(page);
    return page;
  });
  inflight.set(channelId, p);
  void p.finally(() => inflight.delete(channelId));
  return p;
}

export function takeInflight(channelId: string): Promise<ChannelPage> | null {
  return inflight.get(channelId) ?? null;
}

export function cachedPage(channelId: string): ChannelPage | null {
  return pages.get(channelId) ?? null;
}

export function remember(page: ChannelPage): void {
  pages.delete(page.channelId);
  pages.set(page.channelId, page);
  while (pages.size > MAX) pages.delete(pages.keys().next().value!);
}

export function clearPages(): void {
  pages.clear();
  inflight.clear();
}
